import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { useNavigate } from "react-router-dom";
import { FaDownload, FaEye } from "react-icons/fa";
import { useSGPIListById } from "../hooks/useEmployee";
import { downloadExcelGet } from "../../../utils/ExcelDownload";
import { BASE_URL } from "../../../Api/config";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import { showToast } from "../../../utils/toastUtils";

interface AttendanceListProps {
  // Define your props here
  Employee: any;
}

const SGPIList: React.FC<AttendanceListProps> = ({ Employee }) => {
  const navigate = useNavigate();
  const [filtersState, setFiltersState] = useState<any>({
    limit: 10,
    page: 1,
    search: "",
  });

    const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
              const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
              const { startPolling, stopPolling } = useExcelPolling();
  console.log("filterstate", filtersState);
  const SGPIColumns = (handleSGPIDownload: (row: any) => void) => [
    {
      name: "Unique Code",
      selector: (row: { sr: string }) => row.sr,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "SGPI Name",
      selector: (row: { name: string }) => row.name,
      sortable: true,
      minWidth: "180px",
      wrap: true,
    },
    {
      name: "SGPI Code",
      selector: (row: { sgpiCode: string }) => row.sgpiCode,
      sortable: true,
      wrap: true,
      minWidth: "150px",
    },
    {
      name: "Emp Code",
      selector: (row: { employeeCode: string }) => row.employeeCode,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Start Date",
      selector: (row: { startDate: string }) => row.startDate,
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "End Date",
      selector: (row: { endDate: string }) => row.endDate,
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "Balance",
      selector: (row: { balance: string }) => row.balance,
      sortable: true,
      minWidth: "130px",
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <button
          onClick={() => handleSGPIDownload(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "50px" }}
        >
          <FaDownload style={{ fill: "#fff" }} />
        </button>
      ),
    },
  ];

  const { data: SgpiData, isLoading: isLoading } = useSGPIListById({
    enabled: true,
    empId: Employee,
    params: {
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
    },
  });

  const formatSGPIData = () => {
    const data = SgpiData?.data?.data || [];
    return data.map((item: any, index: number) => ({
      sr: item.Uniquecode,
      name: item.SgpiName,
      sgpiCode: item.SgpiCode,
      startDate: item.UseStartDate?.split(" ")[0] || "",
      endDate: item.UseEndDate?.split(" ")[0] || "",
      balance: item.Balance?.toString() || "0",
      employeeCode: item.employeeCode,
      raw: item,
    }));
  };

  // console.log('formatted data',formatSGPIData())
  // console.log('sgpidata',SgpiData?.data)

  const handleSGPIDownload = async (row: any) => {
    const appToken = localStorage.getItem("Apptoken") || "";
    const empId= Employee
 
      const limit=filtersState.limit
      const page =filtersState.page
      const search= filtersState.search
    

    const params = new URLSearchParams();

    // Append only if the value exists

    // if (sortColumn) params.append("sortColumn", sortColumn);
    // if (employee_id) params.append("employee_id", employee_id.toString());
   
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_SGPI_TRANSACTION_LIST_EXCEL}/${row.raw.SgpiId}/${row.raw.EmployeeId}`
        );
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => {showToast.error(msg || "");setLoadingExcel(false)},
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
        setLoadingExcel(false)
      }

  };

         const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
    const empId= Employee
 
      const limit=filtersState.limit
      const page =filtersState.page
      const search= filtersState.search
    

    const params = new URLSearchParams();

    // Append only if the value exists

    // if (sortColumn) params.append("sortColumn", sortColumn);
    // if (employee_id) params.append("employee_id", employee_id.toString());
    if (limit) params.append("limit", limit.toString());
    if (page) params.append("page", page.toString());
    if (search) params.append("search", search);
    
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_SGPI_LIST_EXCEL}/${empId}?${queryString}`
        );
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => {showToast.error(msg || "");setLoadingExcel(false)},
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
        setLoadingExcel(false)
      }
    };


  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (search: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: search,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
  return (
    <div>
      <BasicDataTable
        showSpinner={isLoading}
        dynamicHeightOnRowsPerPage={true}
        paginationTotalRows={SgpiData?.data?.pagination?.total_records}
        Title="SGPI"
        columns={SGPIColumns(handleSGPIDownload)}
        data={formatSGPIData()}
        tableHeaderButtonAfterSearch={true}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        topLeftAlignContent={
          <>
            <button
              onClick={downloadExcelGet}
              className="btn btn-primary"
              style={{
                borderRadius: "20px",
                padding: "5px 10px",
                width: "fit-content",
              }}
            >
              Excel
            </button>
          </>
        }
      />
    </div>
  );
};

export default SGPIList;
